var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WebsiteWrapper',{attrs:{"domain":_vm.domain,"user":_vm.user}},[_c('router-view',{attrs:{"domain":_vm.domain,"user":_vm.user}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }